/**
 * Floor Plan Card Selected Epic
 *
 * Reacts to floorPlanCardSelected action: extracts the currently selected lot ID from state
 * and dispatches navigateTo action to switch to the floor plan detail view with both the
 * selected floor plan ID and currently selected lot ID in context (preserving lot selection
 * when navigating between floor plans).
 *
 * @param {object} params
 * @param {object} params.dataActions - Actions from the feature data slice instance
 * @param {Observable} params.store$ - Redux store state observable
 * @returns {import('redux-observable').Epic}
 */

import { map, withLatestFrom } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { VIEW_FLOOR_PLAN_DETAIL } from '../constants';
import { selectSelectedLotId } from './selectors';

function createFloorPlanCardSelectedEpic({ dataActions, store$ }) {
  return (action$) => action$.pipe(
    ofType(dataActions.floorPlanCardSelected.type),
    withLatestFrom(store$),
    map(([{ payload: floorPlanId }, state]) => {
      // Preserve the currently selected lot when navigating to floor plan detail
      const selectedLotId = selectSelectedLotId(state) ?? null;
      return dataActions.navigateTo({
        view: VIEW_FLOOR_PLAN_DETAIL,
        context: { 
          planId: Number(floorPlanId),
          selectedLotId,
          housingUnitId: null 
        },
      });
    }),
  );
}

export default createFloorPlanCardSelectedEpic;
